import BlueCargoLogo from 'components/BlueCargoLogo';
import * as React from 'react';
import { Policies } from './Policies';
import { ProfileForm } from './ProfileForm';

interface Props {
  proceed: (email: string) => void;
}

export const CreateProfile: React.FC<Props> = (props) => {
  return (
    <div className="p-8">
      <BlueCargoLogo variant="larger-blue" />
      <div className="flex items-center flex-col">
        <div className="max-w-[632px] text-center space-y-8 w-full">
          <h1 className="font-bold">Enter your profile information</h1>
          <ProfileForm proceed={props.proceed} />
          <Policies />
        </div>
      </div>
    </div>
  );
};
CreateProfile.displayName = 'Pages.SignUp.CreateProfile';
